import { useState, useEffect } from 'react';
import { resolvePublicAssetUrl } from '../config/tenantConfig';

/**
 * Exibe logo do tenant; se a imagem não carregar, usa fallback ou o nome.
 */
const TenantBrand = ({
  tenant,
  imageClassName = 'h-8 w-auto object-contain',
  textClassName = 'font-serif text-wine-gold text-sm md:text-base font-semibold tracking-wide',
  fallback = null,
}) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const logoSrc = resolvePublicAssetUrl(tenant?.logo);

  useEffect(() => {
    setLogoFailed(false);
  }, [tenant?.id, logoSrc]);

  if (!tenant) {
    return null;
  }

  if (logoSrc && !logoFailed) {
    return (
      <img
        src={logoSrc}
        alt={tenant.name}
        className={imageClassName}
        loading="eager"
        decoding="async"
        onError={() => setLogoFailed(true)}
      />
    );
  }

  if (fallback) {
    return fallback;
  }

  if (tenant.id === 'default') {
    return null;
  }

  return <span className={textClassName}>{tenant.name}</span>;
};

export default TenantBrand;
